export default __webpack_public_path__ + "static/media/Evaluación Funcional Biomecánica IHP.8623cfcd.docx";